import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

const boxes = [
  {
    text: 'Join the team!',
    image: <StaticImage src="../../../assets/bannerlinks/jointheteam.webp" alt='' />,
    link: '/karriere',
    linkText: 'Bewerbung'
  },
  {
    text: 'Ready to take off?',
    image: <StaticImage src="../../../assets/bannerlinks/takeoff.webp" alt='' />,
    link: '/kontakt',
    linkText: 'Kontakt'
  }
]

export default boxes
